import { render } from "./LoginBySocials.vue?vue&type=template&id=9db3e134&scoped=true"
import script from "./LoginBySocials.vue?vue&type=script&lang=js"
export * from "./LoginBySocials.vue?vue&type=script&lang=js"

import "./LoginBySocials.vue?vue&type=style&index=0&id=9db3e134&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db3e134"]])

export default __exports__